import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { computeFont } from '../utils/fonts';

import * as styles from './ListItem.css';
import type { ListItemElementProps } from './ListItem.types';

export function ListItemElement(props: ListItemElementProps) {
  const { element, children, attributes, className, ...rest } = props;
  const { customAttributes, textStyleAttrs } = element.attrs || {};
  const { color, fontWeight, fontFamily, fontSize, mobileFontSize, fontStyle } = textStyleAttrs || {};

  return (
    <li
      {...customAttributes}
      {...rest}
      className={classNames(className, styles.listItemElement, customAttributes?.className)}
      style={
        {
          '--marker-color': color,
          '--marker-font-weight': fontWeight,
          '--marker-font-family': computeFont(fontFamily),
          '--marker-font-size': fontSize,
          '--marker-mobile-font-size': mobileFontSize,
          '--marker-font-style': fontStyle,
          // This adds the ability to override styles for editor purposes.
          ...((rest.style || {}) as CSSProperties),
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </li>
  );
}
